import 'core-js/es6/symbol';
import angular from 'angular';
import 'angular-sanitize';
import 'angular-i18n/fr-fr.js';
import 'ng-redux';
import reducers from './reducers/combine-reducers';
import thunk from 'redux-thunk';
import 'angular-ui-notification';
import 'angular-messages';
import 'angular-ui-mask';
import 'angular-ui-router';
import 'angular-ui-switch';
import 'ui-select';
import 'angularjs-datepicker';

// Workaround pour que les modifications sur le fichier index.html soient
// surveillées par Webpack
// Le if permet de ne pas ajouter cette dépendence en mode production
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!./index.html');
  require('raw-loader!./favicon.png');
}

require('./app.scss');

import commonModule from './modules/common/common.module';
import baseModule from './modules/base/base.module';
import accueilModule from './modules/accueil/accueil.module';
import antennisteModule from './modules/antenniste/antenniste.module';
import lteModule from './modules/lte/lte.module';
import prtvModule from './modules/prtv/prtv.module';
import suivieModule from './modules/suivie-dossier/suivie-dossier.module';
import mainRouterConfig from './main-routes';

angular
  .module('dmattnt', [
    commonModule.moduleName,
    baseModule.moduleName,
    accueilModule.moduleName,
    antennisteModule.moduleName,
    lteModule.moduleName,
    prtvModule.moduleName,
    suivieModule.moduleName,
    'ngLocale',
    'ui.select',
    'ngSanitize',
    'ui.router',
    'uiSwitch',
    'ngRedux',
    'ui-notification',
    'ui.mask',
    '720kb.datepicker',
    'ngMessages'
  ])
  .config(mainRouterConfig)
  .config(/* @ngInject */($ngReduxProvider) => {
    const middlewares = [thunk];
    if (process.env.NODE_ENV === 'development') {
      const createLogger = require(`redux-logger`);
      const logger = createLogger({
        level: 'info',
        collapsed: true
      });
      middlewares.push(logger);
    }

    $ngReduxProvider.createStoreWith(reducers, middlewares);
  })
  .run(/* @ngInject */($templateCache) => {
    $templateCache.put('selectize/select.tpl.html', require('./ui-select/selectize/select.tpl.html'));
  })
  .config(['uiMask.ConfigProvider', (uiMaskConfigProvider) => {
    uiMaskConfigProvider.clearOnBlur(false);
  }]);

// bootstrap angular app
angular.element(document.body).ready(() => angular.bootstrap(document.body, ['dmattnt']));



// WEBPACK FOOTER //
// ./src/app.js